// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
            fi-change-password-tooltip {
                color: #333;
                text-align: left;
            }
        `, "",{"version":3,"sources":["webpack://./Source/app/components/change-password-tooltip/change-password-tooltip.component.ts"],"names":[],"mappings":";YACY;gBACI,WAAW;gBACX,gBAAgB;YACpB","sourcesContent":["\n            fi-change-password-tooltip {\n                color: #333;\n                text-align: left;\n            }\n        "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
